<template>
  <div>
    <v-card flat tile class="pr-10">
      <v-card-text class="pl-0 mt-10 pt-0 pr-0">
        <div>
          <v-col class="d-inline-block pl-0 pb-0" cols="2" height="50px">
            <v-select
              v-model="searchPayload.search_type"
              :items="searchSelectItems"
              outlined
              dense
              height="50px"
            ></v-select>
          </v-col>

          <v-col cols="3" class="d-inline-block pb-0" height="50px">
            <v-text-field
              outlined
              dense
              height="50px"
              v-model="searchPayload.search_value"
              @keypress.enter="execSearch"
            ></v-text-field>
          </v-col>

          <div class="row justify-center d-inline-block ml-2" height="50px">
            <v-btn
              large
              color="grey darken-4"
              class="white--text"
              dense
              height="50px"
              style="width:120px;"
              @click.prevent="execSearch"
              >조회</v-btn
            >
            <v-btn
              large
              style="margin-left: 20px;"
              height="50px"
              @click.prevent="resetSearch"
              >초기화</v-btn
            >
          </div>
        </div>

        <div class="row justify-center d-inline-block">
          <v-btn
            small
            color="green"
            class="white--text ml-3 mr-3"
            @click="referenceInfoModal = true"
            >카페24 연동형 옵션/세트 상품 참고</v-btn
          >
        </div>

        <v-card class="col-12 mt-6 mb-4 pb-0">
          <div class="row justify-end mt-0 mb-3 mr-5">
            <v-btn
              small
              color="primary"
              class="white--text"
              @click="variantAllAdd()"
              >품목 일괄 추가</v-btn
            >
          </div>
          <v-data-table
            :headers="headers"
            :items="productInfos"
            :server-items-length="2000"
            :hide-default-footer="true"
          >
            <template
              v-slot:[`item.image`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col>
                  <v-img
                    v-if="item.list_image"
                    :src="item.list_image"
                    width="60px"
                    height="60px"
                  ></v-img>
                  <v-img
                    v-else
                    :src="adminDefaultImg"
                    width="60px"
                    height="60px"
                  ></v-img>
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.productInfo`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col
                  class="ml-0"
                  :cols="11"
                  style="max-width: 480px; overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap;"
                >
                  <p class="mb-0 mt-3 text-left text-truncate caption">
                    상품명 : {{ item.product_name }}
                  </p>
                  <p class="mb-0 text-left text-truncate caption">
                    품목명 : {{ item.variant_name }}
                  </p>
                  <p class="mb-0 text-left text-truncate caption">
                    상품코드 : {{ item.product_code }}
                  </p>
                  <p class="mb-3 text-left text-truncate caption">
                    품목코드 : {{ item.variant_code }}
                  </p>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.displayState`]="{ item }" class="pl-0 pr-0">
              <p class="mb-0 text-center">{{ item.display | display }}</p>
            </template>

            <template v-slot:[`item.productState`]="{ item }" class="pl-0 pr-0">
              <p class="mb-0 text-center">{{ item.selling | selling }}</p>
            </template>

            <template v-slot:[`item.stockCount`]="{ item }" class="pl-0 pr-0">
              <p class="mb-0 text-center">{{ item.quantity }}</p>
            </template>

            <template
              v-slot:[`item.itemAddButton`]="{ item }"
              class="pl-0 pr-0"
            >
              <v-btn
                large
                color="purple lighten-1"
                class="white--text d-inline-block"
                v-bind:style="styleSize"
                :key="item.itemAddButton"
                @click.prevent="addProduct(item)"
                >추가</v-btn
              >
            </template>

            <template slot="no-data">
              <div class="noDataProductInfos">내역이 없습니다.</div>
            </template>
          </v-data-table>
        </v-card>

        <p class="mb-0 subtitle-1 font-weight-light mt-10 black--text">
          상품 조회하여 추가한 상품 리스트를 확인해 주세요
        </p>
        <p class="mb-0 subtitle-1 font-weight-light black--text">
          하단의 '정품 인증 코드 생성' 버튼을 클릭하시면 우리 쇼핑몰 상품만의
          정품 인증 DB가 생성됩니다.
          <br />
          안정적인 코드 생성을 위해 1회 생성시 최대 10,000개까지 생성이
          가능합니다.
          <br />
          10,000개 이상 생성하실 경우 나눠서 생성하시길 권장합니다.
        </p>

        <v-card class="col-12 mt-7 mb-4 pb-0">
          <div class="row justify-end mt-0 mb-3 mr-5">
            <v-btn
              small
              color="primary"
              class="white--text"
              @click="createCountSetting()"
              >생성수량 일괄 추가</v-btn
            >
            <v-btn
              v-if="this.productInfosAddList.length > 0"
              small
              color="grey darken-4"
              class="white--text ml-3"
              @click="variantAllModal = true"
              >품목 일괄 삭제</v-btn
            >
            <v-btn
              v-else
              small
              color="grey darken-4"
              class="white--text ml-3"
              @click="variantAllDelete()"
              >품목 일괄 삭제</v-btn
            >
          </div>
          <v-data-table
            :headers="headersAddList"
            :items="productInfosAddList"
            :server-items-length="2000"
            :hide-default-footer="true"
          >
            <template
              v-slot:[`item.image`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col>
                  <v-img
                    v-if="item.list_image"
                    :src="item.list_image"
                    width="60px"
                    height="60px"
                  ></v-img>
                  <v-img
                    v-else
                    :src="adminDefaultImg"
                    width="60px"
                    height="60px"
                  ></v-img>
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.productInfo`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-row no-gutters>
                <v-col
                  :cols="11"
                  class="pl-0 pr-0 ml-0 mr-0"
                  style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap;"
                >
                  <p class="mb-0 mt-3 text-left text-truncate caption">
                    상품명 : {{ item.product_name }}
                  </p>
                  <p class="mb-0 text-left text-truncate caption">
                    품목명 : {{ item.variant_name }}
                  </p>
                  <p class="mb-0 text-left text-truncate caption">
                    상품코드 : {{ item.product_code }}
                  </p>
                  <p class="mb-3 text-left text-truncate caption">
                    품목코드 : {{ item.variant_code }}
                  </p>
                </v-col>
              </v-row>
            </template>

            <template
              v-slot:[`item.warrantyPeriodDays`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <div no-gutters class="pl-0 pr-0 ml-0 mr-0">
                <v-select
                  v-model="item.cert_duration_type"
                  :items="authDateKind"
                  dense
                  height="50px"
                  class="d-inline-block body-2 ml-0 mr-0 pl-0 pr-0"
                  v-bind:style="selectStyleSize"
                  outlined
                ></v-select>

                <v-text-field
                  v-model="item.days"
                  height="50px"
                  class="d-inline-block ml-1 body-2"
                  dense
                  v-bind:style="styleSize"
                  type="number"
                  outlined
                  min="1"
                  max="9999"
                  :ref="`inputDays_${item.index}`"
                  @keydown="M.checkNumber($event)"
                  @keyup="M.replaceDateCount($event, item.days_type)"
                  @blur="M.replaceDateCount($event, item.days_type)"
                ></v-text-field>

                <v-select
                  v-model="item.days_type"
                  :items="days"
                  dense
                  height="50px"
                  @change="initCount(item.index)"
                  class="d-inline-block ml-1 body-2"
                  v-bind:style="{ width: '100px', height: '50px' }"
                  outlined
                ></v-select>
              </div>
            </template>

            <template
              v-slot:[`item.codeCount`]="{ item }"
              class="pl-0 pr-0 ml-0 mr-0"
            >
              <v-text-field
                outlined
                dense
                height="50px"
                class="d-inline-block ml-0 mr-0 pl-0 pr-0"
                v-model="item.number_of_serial"
                type="number"
                max="10000"
                min="1"
                @keydown="M.replaceMaxNumber($event, 6, true)"
                @keyup="M.replaceMaxNumber($event, 6, true)"
                @keypress="M.replaceMaxNumber($event, 6, true)"
                @blur="M.replaceMaxNumber($event, 6, true)"
                hide-details
              ></v-text-field>
            </template>
            <template
              v-slot:[`item.itemDeleteButton`]="{ item }"
              class="pl-0 pr-0"
            >
              <v-btn
                large
                height="50px"
                color="grey darken-4"
                class="white--text d-inline-block ml-0 mr-0 pl-0 pr-0"
                v-bind:style="styleSize"
                :key="item.itemDeleteButton"
                @click.prevent="
                  removeAddItem(item.product_code, item.variant_code)
                "
                >삭제</v-btn
              >
            </template>
            <template slot="no-data">
              <div class="noDataProductInfos">내역이 없습니다.</div>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>

    <div class="row justify-center col-12 mt-7 mb-4 pb-0">
      <v-btn x-large color="primary" dark @click.prevent="execSerials"
        >정품 인증 코드 생성</v-btn
      >
    </div>
    <v-row justify="center">
      <v-dialog persistent max-width="280" v-model="generateSerialsDialog">
        <v-card>
          <v-card-title class="headline">완료되었습니다.</v-card-title>
          <v-card-text>
            <p class="mb-0">생성된 정품 인증 코드 내역은</p>
            <p class="mb-0">[정품 인증 코드 관리]</p>
            <p class="mb-0">메뉴에서 확인이 가능합니다.</p>
            <p class="mb-0">※ 엑셀 다운로드 및 인쇄 가능</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click.prevent="generateSerialsDialog = false"
              >닫기</v-btn
            >
            <v-btn
              color="blue darken-1"
              @click.prevent="moveManageAuthcode"
              text
              >확인하러가기</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- modal -->
    <v-row justify="center">
      <v-dialog v-model="referenceInfoModal" max-width="650px">
        <v-card>
          <v-card-title>카페24 연동형 옵션/세트 상품 참고</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 240px;" class="pb-7">
            <p class="font-weight-bold mt-7 mb-0 body-2 black--text">
              카페24 상품 중에 연동형 옵션 상품, 세트 상품을 조회하여
            </p>
            <p class="font-weight-bold mt-0 body-2 black--text">
              정품인증코드를 생성하는 경우 참고해주세요.
            </p>
            <p class="mb-0 font-weight-bold caption text-truncate">
              1. 상품 연동형 옵션 상품인 경우
            </p>
            <p class="mb-0 caption text-truncate">
              상품 연동형 옵션은 각 품목으로 분리되어 처리가 되지 않습니다.
            </p>
            <p class="mb-0 caption text-truncate">
              단일 상품으로 사용을 하시거나 다른 옵션을 이용하여 정품인증코드를
              사용하시길 권장합니다.
            </p>
            <br />
            <p class="mb-0 font-weight-bold caption text-truncate">
              2. 세트 상품인 경우
            </p>
            <p class="mb-0 caption text-truncate">
              카페24 세트 상품의 경우 세트에 속한 상품을 결합하여 만듭니다.
            </p>
            <p class="mb-0 caption text-truncate">
              세트 상품은 결합된 상품 자체를 한개의 단일 상품으로 조회되오니
              참고하시어 사용해주세요.
            </p>
            <p class="mb-0 caption text-truncate">
              세트에 속한 상품은 각각 조회되므로 쇼핑몰 운영 정책에 맞게
              정품인증코드를 관리하시길 바라겠습니다.
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="referenceInfoModal = false"
              >닫기</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--
      Modal
    -->
    <v-row justify="center">
      <v-dialog v-model="createCountSettingModal" max-width="370px">
        <v-card>
          <v-card-title>생성 수량 일괄 추가</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 200px;" class="pb-7">
            <p class="font-weight-bold mt-7 body-1 black--text mb-2">
              정품인증코드 생성 수량을 입력해주세요.
            </p>
            <p class="mb-0 caption text-truncate">
              추가한 목록의 품목별 정품 인증 코드를
            </p>
            <p class="mb-0 caption text-truncate">
              동일한 수량으로 생성하실때 사용하시면 편리합니다.
            </p>
            <p class="mb-0 caption text-truncate">
              1회 생성시 총 10,000개까지 생성이 가능합니다.
            </p>
            <v-col class="pl-0 pb-0">
              <v-text-field
                v-model="createCount"
                solo
                height="50px"
                class="d-inline-block durationCountText mr-2 mt-3"
                :style="{ width: '80px' }"
                @keydown="M.replaceMaxNumber($event, 6, true)"
                @keyup="M.replaceMaxNumber($event, 6, true)"
                @keypress="M.replaceMaxNumber($event, 6, true)"
                @blur="M.replaceMaxNumber($event, 6, true)"
              ></v-text-field>
              <font class="body-2 font-weight-bold">개</font>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="createCountSettingModal = false"
              >닫기</v-btn
            >
            <v-btn color="blue darken-1" text @click="createCountSave()"
              >저장</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="variantAllModal" max-width="380px">
        <v-card>
          <v-card-title>품목 일괄 삭제</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pb-0">
            <p class="body-2 black--text mt-5 mb-0">
              추가한 상품 리스트의 품목을
            </p>
            <p class="body-2 black--text">일괄 삭제 하시겠습니까?</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="variantAllModal = false"
              >취소</v-btn
            >
            <v-btn color="blue darken-1" text @click="variantAllDelete()"
              >삭제</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
</style>

<script>
import { AUTH_SERVICE } from "@/datas/authservice";
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      M,
      AUTH_SERVICE,
      tabs: 2,
      searchSelectItems: [
        {
          text: "상품명",
          value: "product_name",
        },
        {
          text: "상품코드",
          value: "product_code",
        },
        {
          text: "자체상품코드",
          value: "custom_product_code",
        },
      ],
      searchPayload: {
        search_type: "product_name",
        search_value: "",
      },
      authDateKind: [
        {
          text: "정품 인증일 기준",
          value: AUTH_SERVICE.ACTIVATED,
        },
        {
          text: "코드 생성일 기준",
          value: AUTH_SERVICE.CREATED,
        },
        {
          text: "정품 구매일 기준",
          value: AUTH_SERVICE.BOUGHT,
        },
      ],
      days: [
        {
          text: "일",
          value: "d",
        },
        {
          text: "개월",
          value: "m",
        },
        {
          text: "년",
          value: "y",
        },
      ],
      selectStyleSize: {
        width: "180px",
        height: "50px",
      },
      styleSize: {
        width: "70px",
        height: "50px",
      },
      drawer: null,
      drawerRight: null,
      left: false,
      headers: [
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70,
        },
        {
          text: "품목정보",
          align: "center",
          value: "productInfo",
          sortable: false,
        },
        {
          text: "진열상태",
          width: 100,
          align: "center",
          value: "displayState",
          sortable: false,
        },
        {
          text: "판매상태",
          width: 100,
          align: "center",
          value: "productState",
          sortable: false,
        },
        {
          text: "재고수량",
          width: 100,
          align: "center",
          value: "stockCount",
          sortable: false,
        },
        {
          text: "품목 추가",
          width: 100,
          align: "center",
          value: "itemAddButton",
          sortable: false,
        },
      ],
      headersAddList: [
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70,
        },
        {
          text: "품목정보",
          align: "center",
          value: "productInfo",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
        },
        {
          text: "보증 기간",
          align: "center",
          value: "warrantyPeriodDays",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: "400px",
        },
        {
          text: "생성 수량",
          align: "center",
          value: "codeCount",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 150,
        },
        {
          text: "품목 삭제",
          align: "center",
          value: "itemDeleteButton",
          sortable: false,
          class: "ml-0 mr-0 pl-0 pr-0",
          width: 100,
        },
      ],
      productInfos: [],
      productInfosAddList: [],
      generateSerialsDialog: false,
      intervalProgressValue: 0,
      referenceInfoModal: false,
      createCountSettingModal: false,
      createCount: 0,
      variantAllModal: false,
      adminDefaultImg: require("../../../assets/authservice/images/admin_default.png"),
    };
  },
  filters: Filters,
  mixins: [CommonMixin],
  props: ["duration"],
  methods: {
    /**
     * 검색
     */
    execSearch: async function() {
      this.searchPayload.search_value = this.searchPayload.search_value.trim();
      if (this.searchPayload.search_value === "") {
        let searchType = this.searchSelectItems.filter(
          (item) => this.searchPayload.search_type === item.value
        );
        let str = searchType[0].value === "product_name" ? "을" : "를";
        this.alertShow(`${searchType[0].text}${str} 입력하세요.`);
        return false;
      }
      if (this.searchPayload.search_type === "product_name") {
        if (this.searchPayload.search_value.length < 3) {
          this.alertShow("상품명은 3글자 이상부터 검색이 가능합니다.");
          return false;
        }
      }
      this.defaultProgressShow();
      this.getProductList(this.searchPayload);
    },
    resetSearch: function() {
      this.searchPayload = {
        search_type: "product_name",
        search_value: "",
      };
    },
    /**
     * 상품 가져오기
     */
    getProductList: async function(payload) {
      let data = await M.api(M.entry("/cert/products/search"), payload);
      this.productInfos = data || [];
      this.defaultProgressHide();
    },
    /**
     * 추가 버튼
     */
    addProduct: function(product) {
      var checkAddList = this.productInfosAddList.filter(
        (item) =>
          item.product_code === product.product_code &&
          item.variant_code === product.variant_code
      );

      if (checkAddList.length > 0) {
        this.alertShow("이미 추가된 상품입니다.");
        return false;
      }

      product["cert_duration_type"] = this.duration.cert_duration_type;
      product["cert_duration"] = this.duration.cert_duration;
      product["days"] = this.duration.days;
      product["days_type"] = this.duration.days_type;
      product["number_of_serial"] = "";
      product["index"] = this.productInfosAddList.length;
      this.productInfosAddList.push(product);
    },
    /**
     * 시리얼 데이터 체크
     */
    execSerials: function() {
      let payload = [];
      let checkProduct = true;
      let checkDays = true;
      this.productInfosAddList.forEach((product) => {
        if (product.days === "") {
          checkDays = false;
          return false;
        }
        if (product.number_of_serial === "") {
          checkProduct = false;
          return false;
        }
        payload.push({
          cert_duration_type: product.cert_duration_type,
          cert_duration: `${product.days}${product.days_type}`,
          product_code: product.product_code,
          variant_code: product.variant_code,
          number_of_serial: product.number_of_serial,
        });
      });

      if (!checkDays) {
        this.alertShow(
          "인증코드를 생성하고자 추가하신 상품에</br>보증기간이 미입력된 상품을 확인해주세요."
        );
        return false;
      }

      if (!checkProduct) {
        this.alertShow(
          "인증코드를 생성하고자 추가하신 상품에</br>수량이 미입력된 상품을 확인해주세요."
        );
        return false;
      }

      if (payload.length === 0) {
        this.alertShow(
          "정품 인증 코드를 생성할 상품이 없습니다.</br>상품을 조회하고 추가해주세요"
        );
        return false;
      }

      this.sendGenerateSerials(payload);
    },
    /**
     * 시리얼 생성 전송
     */
    sendGenerateSerials: async function(payload) {
      let total_count = 0;

      for (const item of payload) {
        total_count += Number(item.number_of_serial);
      }

      if (total_count > 10000) {
        alert(
          "입력하신 수량을 확인해주세요.\n1회 생성시 총 10,000개까지 생성이 가능합니다."
        );
        return false;
      }

      let persent = Math.floor((100 / total_count) * 100);
      if (persent > 100) {
        if (payload.length > 1) {
          persent = Math.ceil(100 / payload.length);
        } else {
          persent = 100;
        }
      }
      this.intervalProgressValue = 0;
      let progressText =
        "입력한 상품의 정품 인증 코드가 발급중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);

      for (const item of payload) {
        let _count = Number(item.number_of_serial);
        if (_count > 100) {
          let _loof_count = Math.ceil(_count / 100);
          let _number_of_serial = 0;
          let __count = 100;
          for (let i = 0; i < _loof_count; i++) {
            _number_of_serial += 100;
            if (_number_of_serial > _count) {
              __count = _count - (_number_of_serial - 100);
            }

            let _set_param = [
              {
                cert_duration: item.cert_duration,
                cert_duration_type: item.cert_duration_type,
                number_of_serial: __count,
                product_code: item.product_code,
                variant_code: item.variant_code,
              },
            ];

            await M.api(M.entry("/generate/serials"), _set_param);

            this.intervalProgressValue += persent;
            this.circularProgressSetValue(this.intervalProgressValue);
          }
        } else {
          let _set_param = [
            {
              cert_duration: item.cert_duration,
              cert_duration_type: item.cert_duration_type,
              number_of_serial: Number(item.number_of_serial),
              product_code: item.product_code,
              variant_code: item.variant_code,
            },
          ];

          await M.api(M.entry("/generate/serials"), _set_param);
          this.intervalProgressValue += persent;
          this.circularProgressSetValue(this.intervalProgressValue);
        }
      }

      let interval = setInterval(() => {
        if (this.intervalProgressValue < 100) {
          this.intervalProgressValue = 100;
        }
        this.circularProgressSetValue(this.intervalProgressValue);
        if (this.intervalProgressValue >= 100) {
          setTimeout(() => {
            this.circularProgressHide();
            clearInterval(interval);
            this.generateSerialsDialog = true;
            this.productInfosAddList = [];
          }, 1000);
        }
      }, 200);
    },
    /**
     * 삭제
     */
    removeAddItem: function(productCode, variantCode) {
      let index = this.productInfosAddList.findIndex(
        (item) =>
          item.product_code === productCode && item.variant_code === variantCode
      );
      this.productInfosAddList.splice(index, 1);
    },
    /**
     * page 이동
     */
    moveManageAuthcode: function() {
      this.$router.push({
        path: `/authservice/${this.$store.state.mallId}/manageAuthcode?createAuth=Y`,
      });
    },
    /**
     * 초기화
     */
    initCount: function(index) {
      this.$refs[`inputDays_${index}`].$refs.input.value = "";
      var event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });
      this.$refs[`inputDays_${index}`].$refs.input.dispatchEvent(event);
    },
    /**
     * 닫기 버튼
     * 데이터초기화
     */
    generateSerialsDialogClose: function() {
      this.productInfos = [];
      this.searchPayload = {
        search_type: "product_name",
        search_value: "",
      };
      this.generateSerialsDialog = false;
    },
    createCountNumber: function() {
      this.createCount = this.createCount.replace(/[^0-9]/g, "");
    },
    /**
     * 생성 수량 일괄 설정
     */
    createCountSave: function() {
      let selectCounts = this.productInfosAddList.length;
      if (selectCounts > 0) {
        for (var i = 0; i < selectCounts; i++) {
          this.productInfosAddList[i].number_of_serial = this.createCount;
        }
        this.createCountSettingModal = false;
      } else {
        this.alertShow("추가된 품목이 없습니다.");
      }
    },
    createCountSetting: function() {
      let selectCounts = this.productInfosAddList.length;
      if (selectCounts == 0 || !selectCounts) {
        this.alertShow("추가된 품목이 없습니다.");
        return false;
      }
      this.createCountSettingModal = true;
    },
    /**
     * 품목 일괄 추가
     */
    variantAllAdd: function() {
      let productCnt = this.productInfos.length;
      if (productCnt == 0 || !productCnt) {
        this.alertShow("조회된 품목 정보가 없습니다.");
        return false;
      }

      for (var i = 0; i < productCnt; i++) {
        let product = this.productInfos[i];
        product["cert_duration_type"] = this.duration.cert_duration_type;
        product["cert_duration"] = this.duration.cert_duration;
        product["days"] = this.duration.days;
        product["days_type"] = this.duration.days_type;
        product["number_of_serial"] = "";
        product["index"] = this.productInfosAddList.length;

        let checkAddList = this.productInfosAddList.filter(
          (item) =>
            item.product_code === product.product_code &&
            item.variant_code === product.variant_code
        );

        if (checkAddList.length > 0) {
          continue;
        }
        this.productInfosAddList.push(product);
      }
      this.alertShow("품목 일괄 추가 되었습니다.");
    },
    /**
     * 품목 일괄 제거
     */
    variantAllDelete: function() {
      this.variantAllModal = false;
      let productInfosAddListCnt = this.productInfosAddList.length;
      if (productInfosAddListCnt == 0 || !this.productInfosAddList) {
        this.alertShow("추가한 상품 리스트에 일괄 삭제할 품목이 없습니다.");
        return false;
      }
      this.productInfosAddList = [];
      this.alertShow("추가한 상품 리스트에 품목 일괄 삭제가 되었습니다.");
    },
  },
};
</script>
